import BrandGoalModule from './brand-goal/brand-goal.module';
import ReportScanStatisticsModule from './report-scan-statistics/report-scan-statistics.module';
import ScanSummaryModule from './scan-summary/scan-summary.module';

export default angular.module('sfMobile.components.scans', [
  BrandGoalModule,
  ReportScanStatisticsModule,
  ScanSummaryModule,
]).name;
